import { type AppErrorOptions, BadRequestError, ConflictError } from "../error/errors.ts";
import type { Section } from "../section/section.ts";

export class MoveItemsDestinationWithinSelectionError extends BadRequestError {
  constructor(destinationSectionId: Section["id"]) {
    super(`Cannot move items: destination section ${destinationSectionId} is within the selection`);
    this.name = "MoveItemsDestinationWithinSelectionError";
  }
}

export type MoveItemsError = MoveItemsDestinationWithinSelectionError;

export class AwardedDateRequiresAwardedStatusError extends BadRequestError {
  constructor() {
    super("An awarded date can only be set on a project in an awarded status");
    this.name = "AwardedDateRequiresAwardedStatusError";
  }
}

export const DUPLICATE_INTERNAL_QUOTE_REFERENCE_ERROR_CODE = "DUPLICATE_INTERNAL_QUOTE_REFERENCE";

export class DuplicateInternalQuoteReferenceError extends ConflictError {
  constructor(options?: AppErrorOptions) {
    super("Internal project reference already used in this organisation", {
      ...options,
      code: DUPLICATE_INTERNAL_QUOTE_REFERENCE_ERROR_CODE,
      logLevel: "warn",
    });
    this.name = "DuplicateInternalQuoteReferenceError";
  }
}

export const OUTDATED_PROJECT_VERSION_ERROR_CODE = "OUTDATED_PROJECT_VERSION";

export class OutdatedProjectVersionError extends ConflictError {
  constructor(context: { nextPublicVersion: number; targetPublicVersion: number }) {
    super("Project version is outdated", { code: OUTDATED_PROJECT_VERSION_ERROR_CODE, logLevel: "warn", context });
    this.name = "OutdatedProjectVersionError";
  }
}
